import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import { composeDiamAccountPortalUrl } from '~/domain/users/utils/diam-portal-url-utils';
import { useGetSsoTokenMutation } from '../api/users-api';

export const useDiamAccountPortalUrl = () => {
  const userLocale = useSelector((state: AppState) => state.translation.locale);
  const [getSsoToken, { isSuccess, isUninitialized, data, isLoading, reset }] =
    useGetSsoTokenMutation();
  useEffect(() => {
    if (!isUninitialized && !isLoading) {
      if (data?.ssoToken && isSuccess) {
        const url = composeDiamAccountPortalUrl(data?.ssoToken, userLocale);
        if (!window.open(url, '_blank')) {
          window.location.href = url;
        }
      }
      reset();
    }
  }, [data?.ssoToken, isLoading, isSuccess, isUninitialized, reset, userLocale]);
  const redirectToDiamAccountPortal = () => {
    getSsoToken();
  };
  return {
    redirectToDiamAccountPortal,
  };
};

export default { useDiamAccountPortalUrl };
